import { Button, Color, DefaultValue, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { TitleWrapper } from '../Title/styles'

interface ProfileFormWrapperProps {
  disabled: boolean
}

interface FormItemWrapperProps {
  itemColumnEnd?: number
  itemColumnStart?: number
}

export const ProfileFormWrapper = styled.div<ProfileFormWrapperProps>`
  padding: ${Spacing.S40};
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
  position: relative;
  background-color: ${Color.White};

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;

      /* Overlay */
      &:after {
        content: '';
        opacity: 0.6;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: ${Color.Grey100};
      }
    `}
`

export const FormGrid = styled.section`
  display: grid;
  column-gap: ${Spacing.S40};
  grid-template-columns: repeat(2, 1fr);
`

export const FormRow = styled.div`
  display: grid;
  margin-bottom: ${Spacing.S24};
  grid-row-gap: ${Spacing.S8};

  &:last-of-type {
    margin-bottom: 0;
  }
`

export const FormItemWrapper = styled.div<FormItemWrapperProps>`
  min-width: 0; /* Fix for truncating stuff inside (https://css-tricks.com/flexbox-truncated-text/#aa-the-solution-is-min-width-0-on-the-flex-child) */
  ${({ itemColumnStart }) => itemColumnStart !== undefined && `grid-column-start: ${itemColumnStart};`}
  ${({ itemColumnEnd }) => itemColumnEnd !== undefined && `grid-column-end: ${itemColumnEnd};`}
`

export const LogoSection = styled.section`
  display: flex;
  flex-direction: column;

  ${() => TitleWrapper} {
    margin-bottom: ${Spacing.S8};
  }

  ${() => FormItemWrapper} {
    height: 200px;
  }
`

export const FormButton = styled(Button)`
  margin-top: ${Spacing.S16};
  margin-left: auto;
`
